<template functional>
  <div v-if="props.row.nombre == ' ' || props.row.nombre == ''"></div>
  <div v-else>
    <a
      v-if="
        props.rowValue < 0 && props.rowValue != null && props.column != 'cuenta'
      "
      href="#"
      @click="$options.show(props)"
      class="RojoM"
      :style="
        props.row.negrita == 'S' || props.row.negrita == 'T'
          ? 'font-weight: bold; text-decoration:none; font-size: 13px'
          : 'font-weight: normal; text-decoration:none'
      "
    >
      {{ $options.formatMonto(props.rowValue) }}
    </a>
    <el-input-number
      v-if="
        props.column != 'cuenta' &&
        props.column != 'tot' &&
        props.column !== 'nombre' &&
        props.row.negrita !== 'S' &&
        props.row.negrita !== 'T' /*&&
          data.attrs.editEneable === true /*&&
          data.attrs.rowValue !== null*/
      "
      size="mini"
      v-model="data.attrs.rowValue"
      :precision="2"
      :step="1"
      :controls="false"
      controls-position="right"
      :min="0"
      :max="9999999999999999"
      @blur="($event) => $options.UpdatingValueDb($event, data)"
      @change="
        ($event) =>
          $options.UpdatingValue(
            $event,
            data
          ) /* data.attrs.rowValue = parseFloat($event.target.value)*/
      "
    >
    </el-input-number>
    <a
      v-else-if="props.rowValue >= 0 && props.column != 'cuenta'"
      href="#"
      @click="$options.show(props)"
      class="NegroM"
      :style="
        props.row.negrita == 'S' || props.row.negrita == 'T'
          ? 'font-weight: bold; text-decoration:none; font-size: 13px'
          : 'font-weight: normal; text-decoration:none'
      "
    >
      {{ props.rowValue == null ? " " : $options.formatMonto(props.rowValue) }}
    </a>

    <a
      v-if="props.column == 'cuenta'"
      href="#"
      class="AzulM"
      :style="
        props.row.negrita == 'S' || props.row.negrita == 'T'
          ? 'font-weight: bold; text-decoration:none; font-size: 13px'
          : 'font-weight: normal; text-decoration:none'
      "
    >
      {{ props.rowValue }}
    </a>

    <a
      v-if="props.column == 'nombre'"
      href="#"
      class="NegroM"
      :style="
        props.row.negrita == 'S' || props.row.negrita == 'T'
          ? 'font-weight: bold; text-decoration:none; font-size: 13px'
          : 'font-weight: normal; text-decoration:none'
      "
    >
      {{ props.rowValue }}
    </a>
  </div>
</template>

<script>
import { formatMonto } from "@/utils";
export default {
  formatMonto,
  name: "HyperLinkForBudgetMaster",
  show(ops) {
    ops;
    // console.log("hola", ops);
    // ops.row.OpenDetailDataCliente(ops.row);
    // ops.row.OpenDetailAutoMV(ops.row, ops.column);
  },
  UpdatingValue(event, data) {
    let value =
      typeof event === "number" ? event : parseFloat(event.target.value);
    //data.attrs.rowValue = value;
    data.attrs.row[data.attrs.column] = value;
    //console.log("UpdatingValue: ", value, "\ndata: ", data);

    data.attrs.updatingAccountValue(value, data);
  },
  UpdatingValueDb(event, data) {
    //console.log("UpdatingValue2: ", event, "\ndata2: ", data);
    let value =
      typeof event === "number" ? event : parseFloat(event.target.value);
    data.attrs.row[data.attrs.column] = value;
    //console.log("UpdatingValue2: ", event, "\ndata2: ", data);
    data.attrs.updatingAccountValue(value, data);
  }
  /*,
    computed: {
      newValue() {
        //console.log("hola")
        //console.log("NewValue: ", this.data.attrs.rowValue)
        return this.data.attrs.rowValue
      }
    }*/
};
</script>
<!-- class="Azul" -->
<!-- :class="[props.row.Rojo ? 'Rojo' : 'Azul']" -->

<style scoped>
.RojoM {
  color: #c71d10;
}
.AzulM {
  color: rgb(11, 135, 188);
}
.NegroM {
  color: black;
}
</style>
